import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  Wrapper,
  StyledContainer,
  ImageWrapper,
  OptionalImage,
  Content,
  TitleWrapper,
  PrefineryWrapper,
  Prefinery,
} from './style';

function PrefineryBanner({ sectionId, data, className }) {
  if (!data) return null;
  const {
    headingHtml,
    subheadingHtml,
    image,
    imageSharp,
    colourOverrideBackground,
  } = data;
  const anchor = 'prefinery-form';

  /* Lifecycle function that injects prefinery popup when using the prefinery cta, on component mount for the first time */
  useEffect(() => {
    if (!document.getElementById('prefinery_js')) {
      // script tag with code inside
      const prefineryScript = document.createElement('script');
      prefineryScript.text = `{prefinery=window.prefinery||function()
      {(window.prefinery.q = window.prefinery.q || []).push(arguments)};
        document.body.appendChild(prefineryScript)}`;

      // script tag with js to load from url
      const prefineryJs = document.createElement('script');
      prefineryJs.src = 'https://widget.prefinery.com/widget/v2/rcprmg1r.js';
      prefineryJs.id = 'prefinery_js';
      document.body.appendChild(prefineryJs);
    }
  }, []);

  return (
    <Wrapper
      id={sectionId}
      className={[className]}
      colourOverrideBackground={colourOverrideBackground}
    >
      <StyledContainer>
        <Content id={anchor}>
          <TitleWrapper>
            {ReactHtmlParser(headingHtml)}
            {ReactHtmlParser(subheadingHtml)}
          </TitleWrapper>
          {/* Prefinery form injection  */}
          <PrefineryWrapper>
            <Prefinery className="prefinery-form-embed" />
          </PrefineryWrapper>
        </Content>
        {image.url && imageSharp && (
          <ImageWrapper>
            <OptionalImage
              src={imageSharp}
              alt={image.altTag}
              objectFit="cover"
            />
          </ImageWrapper>
        )}
      </StyledContainer>
    </Wrapper>
  );
}

PrefineryBanner.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PrefineryBanner.defaultProps = {
  className: null,
};

export default PrefineryBanner;
